// ** Redux
import { vendor } from "store/vendor";
import { updateProfileDetails } from "store/modules/global-user/global-user.slice";
import { setLanguageAsync } from "store/modules/global-common.slice";

// ** Third party
import md5 from "md5";

// #####################################################

export default function saveUserData(headers, config) {
	const header = headers ? headers["datezone-user-data"] || null : null;

	if (header == null) {
		return "";
	}

	const language = config?.headers["Accept-Language"] || "pl";

	const userDataHeader = Buffer.from(header, "base64").toString();
	const userDataHeaderHash = md5(userDataHeader);

	/**
	 * Parsowanie nagłówka z base64
	 */
	const user = JSON.parse(userDataHeader);

	// Zmiana języka w momencie kiedy w nagłówku przyjdzie inny niż był dotychczas ustawiony
	if (language !== user.user_language) {
		vendor.store.dispatch(
			setLanguageAsync({
				language: user.user_language,
				auth: false,
				setCookie: true,
			}),
		);
	}

	const userDataHeaderHashFromStore =
		vendor.store.getState().globalUser.userDataHeaderHash;

	/**
	 * Zapis do stora liczników
	 */
	if (userDataHeaderHashFromStore !== userDataHeaderHash) {
		setTimeout(() => {
			vendor.store.dispatch(
				updateProfileDetails({
					...user,
					userDataHeaderHash,
				}),
			);
		}, 100);
	}

	return header;
}

// #####################################################
